var map = {
	"./chat.js": "VAhz",
	"./district.js": "a2Hv",
	"./global.js": "17x+",
	"./index.js": "2mV7",
	"./user.js": "bREw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gNcp";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules nonrecursive \.js$
// module id = gNcp
// module chunks = 1